import { LAST_CLICKED_RECOMMENDED_AGENT_KEY } from '../../common/constants/private.ts';

type AgentData = {
	agentId: string;
	recommendationKey: string;
};

// To be removed in QRA-485 + chat analytics use in /ai-mate/conversation-assistant/src/controllers/chat-store/send-message-action.ts
export const setLastClickedRecommendedAgent = (data: AgentData | null): void => {
	if (!data) {
		sessionStorage.removeItem(LAST_CLICKED_RECOMMENDED_AGENT_KEY);
	} else {
		sessionStorage.setItem(LAST_CLICKED_RECOMMENDED_AGENT_KEY, JSON.stringify(data));
	}
};

export const getLastClickedRecommendedAgent = (): AgentData | null => {
	const data = sessionStorage.getItem(LAST_CLICKED_RECOMMENDED_AGENT_KEY);
	return data ? JSON.parse(data) : null;
};
